export default {
  EXP: {
    name: 'files',
    view: 'general',
    query: 'febosId:'
  },
  APR: {
    name: 'approval-trays',
    view: 'general',
    query: 'id:'
  }
};
